import { render, staticRenderFns } from "./recpritake.vue?vue&type=template&id=53cc5770&scoped=true&"
import script from "./recpritake.vue?vue&type=script&lang=js&"
export * from "./recpritake.vue?vue&type=script&lang=js&"
import style0 from "./recpritake.vue?vue&type=style&index=0&id=53cc5770&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc5770",
  null
  
)

export default component.exports